// components/A4ResponsiveWrapper.tsx
import { Box, VStack } from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";

export const A4ResponsiveWrapper = ({
  children,
  isDownload,
}: {
  children: React.ReactNode;
  isDownload: boolean;
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [scale, setScale] = useState(1);

  useEffect(() => {
    const updateScale = () => {
      if (!containerRef.current) return;

      const containerWidth = containerRef.current.offsetWidth;
      const A4_WIDTH_PX = 794;

      // Calculate scale based on available width
      const calculatedScale = containerWidth / A4_WIDTH_PX;

      // Never scale up beyond 1, but always scale down on smaller screens
      setScale(Math.min(calculatedScale, 1));
    };

    updateScale();

    // Use ResizeObserver for better performance
    const resizeObserver = new ResizeObserver(updateScale);
    if (containerRef.current) {
      resizeObserver.observe(containerRef.current);
    }

    window.addEventListener("resize", updateScale);

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener("resize", updateScale);
    };
  }, []);

  return (
    <Box
      ref={containerRef}
      w="100%"
      minH="100vh"
      display="flex"
      justifyContent="center"
      alignItems="flex-start"
      bg="gray.100"
      py={{ base: 2, md: 4 }}
      overflow="hidden" // Prevent horizontal scroll
    >
      <Box
        w="100%"
        maxW="794px"
        display="flex"
        justifyContent="center"
        overflow="hidden" // Critical: prevent overflow
      >
        <VStack
          transform={isDownload ? undefined : `scale(${scale})`}
          transformOrigin="top center"
          className="print-area"
          spacing={0}
          gap={isDownload ? 0 : { base: 2, md: 3 }}
          transition="transform 0.2s ease-out"
          w="794px"
          minW="794px" // Prevent shrinking
        >
          {children}
        </VStack>
      </Box>
    </Box>
  );
};
